
// 
import WebComponent from '../webComponents/WebComponent';
import * as CursorSpinner from './CursorSpinner';

export default class Form extends WebComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  didMount() {
    const {
      preventMultipleSubmit,      // zabrana proti vicenasobnemu odeslani formulare
      submitOnChange,             // provede submit v pripade vyvolani change eventy na komponentach formulare
      turbolinksForm,           // odeslani formulare ajax requestem
    } = this.props;

    CursorSpinner.removeFromQueue('FormSubmit');

    if (preventMultipleSubmit !== false || turbolinksForm === true) this.on('submit', this.handleSubmit);
    if (submitOnChange === true) {
      this.inputElements = this.element.querySelectorAll('input:not([type="submit"])');
      this.handleSubmitOnChange();
    }
  }

  willUnMount() {
    const {
      submitOnChange,
    } = this.props;

    if (submitOnChange === true && this.inputElements) {
        this.inputElements.forEach((inputElement) => {
          inputElement.removeEventListener('change', this.handleChange);
        });
    }
    this.inputElements = null;
  }

  /*
    Zamezeni pred vicenasobnym odeslanim formulare
   */
  handleSubmit() {
    const {
      preventMultipleSubmit,      // zabrana proti vicenasobnemu odeslani formulare
      turbolinksForm,           // odeslani formulare ajax requestem
    } = this.props;

    CursorSpinner.pushToQueue('FormSubmit');

    const submitElements = this.element.querySelectorAll('[type="submit"]');

    if (preventMultipleSubmit !== false) {
      setTimeout(() => {
        if (submitElements) {
          submitElements.forEach((submitElement) => {
            submitElement.setAttribute('disabled', 'disabled');
          });
        }
      }, 1)
    }

    if ((turbolinksForm === true) && (typeof(Turbolinks) != 'undefined')) {
      event.preventDefault();

      const xhr = new XMLHttpRequest();
      const formData = new FormData(this.element);
      const requestUrl = this.element.getAttribute('action');

      submitElements.forEach((submitElement) => {
       formData.append(submitElement.name, submitElement.value);
      });

      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.responseURL.indexOf(requestUrl, xhr.responseURL.length - requestUrl.length) == -1) {
            Turbolinks.visit(xhr.responseURL);
          }
          else {
            const res = document.createElement('div');
            res.innerHTML = xhr.responseText;
            this.element.innerHTML = res.querySelector('#' + this.element.id).innerHTML;
          }
        }
      };

      xhr.open(this.element.getAttribute('method'),requestUrl, true);
      xhr.send(formData);
    }
  }

  /*
    Submit formulare pri zmene
   */
  handleChange() {
    this.element.submit();
  }

  /*
    Osetreni submitu formulare pri zmene inputu
   */
  handleSubmitOnChange() {
    if (this.inputElements) {
      this.inputElements.forEach((inputElement) => {
        inputElement.addEventListener('change', this.handleChange);
      });
    }
  }
}




// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/Form.js